export class FpsMonitor {
    constructor(params) {
        // The time in ms to wait between rendering frames. The higher the value, the less CPU usage.
        this._renderOffset = 30;
        // Only apply fps throttling if the frame render time is more than this value
        this._limitFpsWorseThan = 5;
        this._lastDrawTime = 0;
        this._lastDrawFinish = 0;
        this._frameDropped = false;
        this._maxMeasuredFpsInterval = 0;
        this._lastFpsMark = 0;
        this._minFpsInterval = 0;
        this._maxFpsInterval = 0;
        this._averageFrameTimes = {};
        const { minFps, durationInSeconds, shouldLimitFps } = params;
        this._shouldLimitFps = shouldLimitFps;
        this._duration = durationInSeconds;
        // Convert fps value to ms interval by deviding 1000 by the fps value
        this._maxFpsInterval = Math.floor(1000 / minFps);
    }
    setMaxFpsInterval_m(maxFpsIntervalInMs) {
        this._maxFpsInterval = maxFpsIntervalInMs;
    }
    markDrawStart_m(t) {
        this._lastDrawTime = t;
    }
    canDraw_m(t) {
        var _a;
        if (!this._shouldLimitFps) {
            return true;
        }
        if (this._frameDropped && t - this._lastDrawFinish < this._currentFpsInterval) {
            return false;
        }
        // drop the frame
        if (!this._frameDropped && t - this._lastDrawFinish < this._renderOffset) {
            this._frameDropped = true;
            return false;
        }
        this._frameDropped = false;
        const shouldSkip = !!this._lastDrawTime &&
            t - this._lastDrawTime < ((_a = this._currentFpsInterval) !== null && _a !== void 0 ? _a : this._minFpsInterval);
        return !shouldSkip;
    }
    markDrawFinish_m(animationTimeInSeconds) {
        const frameTime = performance.now() - this._lastDrawTime;
        const timeRange = [
            Math.floor(animationTimeInSeconds),
            Math.floor(animationTimeInSeconds) + 1
        ];
        if (!this._currentFpsInterval) {
            this._currentFpsInterval = this._getFpsIntervalBasedOnFrameTime(frameTime);
        }
        if (this._lastFpsMark !== timeRange[0]) {
            this._saveFrameRenderTimes(timeRange);
            this._currentFpsInterval = this._getBestFpsIntervalForTimeRange(timeRange);
        }
        else {
            if (this._maxMeasuredFpsInterval < frameTime) {
                this._maxMeasuredFpsInterval = frameTime;
            }
        }
        this._lastDrawFinish = performance.now();
    }
    _getFpsIntervalBasedOnFrameTime(frameTime) {
        if (frameTime < this._limitFpsWorseThan) {
            return 0;
        }
        return Math.min(frameTime + this._renderOffset, this._maxFpsInterval);
    }
    _getLastTimeStart(timeRange) {
        return timeRange[0] - 1 < 0 ? Math.floor(this._duration) : timeRange[0] - 1;
    }
    _saveFrameRenderTimes(timeRange) {
        const maxFpsInterval = Math.ceil(this._maxMeasuredFpsInterval);
        const newFpsInterval = this._getFpsIntervalBasedOnFrameTime(maxFpsInterval);
        this._maxMeasuredFpsInterval = 0;
        this._lastFpsMark = timeRange[0];
        this._averageFrameTimes[this._getLastTimeStart(timeRange)] = newFpsInterval;
        return newFpsInterval;
    }
    _getBestFpsIntervalForTimeRange(timeRange) {
        var _a, _b;
        const currentTimeStart = timeRange[0];
        const lastTimeStart = this._getLastTimeStart(timeRange);
        return ((_b = (_a = this._averageFrameTimes[currentTimeStart]) !== null && _a !== void 0 ? _a : this._averageFrameTimes[lastTimeStart]) !== null && _b !== void 0 ? _b : this._maxFpsInterval);
    }
}
